<template>
  <div class="image-box">
    <img
      v-if="showPropertiesHolder.imageSrcList.length === 1"
      :src="showPropertiesHolder.imageSrcList[0]"
      :style="{objectFit: showPropertiesHolder.imageStyle, cursor: showPropertiesHolder.imageToUrl ? 'pointer' : 'default'}"
      @click="onClickImage">
    <el-carousel
      v-if="showPropertiesHolder.imageSrcList.length > 1"
      :interval="5000"
      arrow="always">
      <el-carousel-item v-for="imgSrc in showPropertiesHolder.imageSrcList" :key="imgSrc">
        <img
          :src="imgSrc"
          :style="{objectFit: showPropertiesHolder.imageStyle, cursor: showPropertiesHolder.imageToUrl ? 'pointer' : 'default'}"
          @click="onClickImage">
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
  import current from "./mixin"
  export default {
    mixins: [current],
    data() {
      return {
        aEle: null
      }
    },
    created() {
      if (this.current.showPropertiesHolder.dataType === 'FIELD') {
        const showHolder = this.current.showPropertiesHolder
        this.$store.dispatch('actionFilterFormData', {
          appId: showHolder.relateConfig.appId,
          formId: showHolder.relateConfig.formId,
          filterInfo: showHolder.relateConfig.filterInfo,
          advancedFilter: showHolder.relateConfig.advancedFilter,
          tableFieldId: showHolder.relateConfig.tableFieldId,
          advancedFilterInfo: showHolder.relateConfig.advancedFilterInfo,
          fieldId: showHolder.relateConfig.fieldId,
        }).then(res => {
          showHolder.imageSrcList = res[showHolder.relateConfig.fieldId] ? res[showHolder.relateConfig.fieldId].map(item => item.imgUrl) : []
        }).catch(console.error)
      }
    },
    methods: {
      onClickImage() {
        if (this.showPropertiesHolder.imageToUrl) {

          if (!this.aEle) {
            this.aEle = document.createElement('a')
          }
          this.aEle.href = this.showPropertiesHolder.imageToUrl
          this.aEle.target = this.showPropertiesHolder.jumpType
          this.aEle.click()
        }
      }
    }
  }
</script>

<style lang="less">
  .image-box {
    width: 100%;
    height: 100%;

    .el-carousel {
      height: 100%;

      .el-carousel__container {
        height: 100%;
      }
    }

    img {
      height: 100%;
      width: 100%;
    }
  }
</style>
